import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: 'Instagram', url: 'https://www.instagram.com/knowndisc/', icon: 'fab fa-instagram', color: '#E1306C' },
    { name: 'Twitter',   url: 'https://x.com/knowndisc2',            icon: 'fab fa-twitter',   color: '#1DA1F2' },
    { name: 'YouTube',   url: 'https://www.youtube.com/@knowndisc',  icon: 'fab fa-youtube',   color: '#FF0000' },
    { name: 'VGen',      url: 'https://vgen.co/knowndisc',           icon: 'fas fa-paint-brush', color: '#8A2BE2' },
    { name: 'Email',     url: 'mailto:knowndisc.questionmail@gmail.com', icon: 'fas fa-envelope', color: '#34A853' }
  ];

  const linkGroups = [
    {
      title: 'Explore',
      links: [
        { label: 'Home', to: '/' },
        { label: 'Portfolio', to: '/portfolio' },
        { label: 'About', to: '/about' },
        { label: 'Commissions', to: '/commissions' }
      ]
    },
    {
      title: 'Social',
      links: [
        { label: 'Instagram', href: 'https://www.instagram.com/knowndisc/' },
        { label: 'YouTube', href: 'https://www.youtube.com/@knowndisc' },
        { label: 'Twitter/X', href: 'https://x.com/knowndisc2' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy', href: '#' },
        { label: 'Terms', href: '#' }
      ]
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.05, delayChildren: 0.1 }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 8 },
    show: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 300, damping: 20 } }
  };

  return (
    <motion.footer
      className="footer"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      role="contentinfo"
    >
      <div className="footer-content">
        <div className="footer-brand">
          <h2 className="footer-heading">KNOWNDISC</h2>
          <a href="mailto:knowndisc.questionmail@gmail.com" className="footer-email">knowndisc.questionmail@gmail.com</a>
        </div>

        <nav className="footer-links" aria-label="Footer navigation">
          {linkGroups.map((group) => (
            <div className="footer-group" key={group.title}>
              <h3 className="footer-group-title">{group.title}</h3>
              <ul className="footer-list">
                {group.links.map((l) => (
                  <li key={l.label}>
                    {l.to ? (
                      <Link to={l.to} className="footer-link">{l.label}</Link>
                    ) : (
                      <a href={l.href} className="footer-link" target="_blank" rel="noopener noreferrer">{l.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <motion.div className="social-links" variants={container} initial="hidden" animate="show">
          {socialLinks.map((social) => (
            <motion.a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              variants={item}
              whileHover={{ scale: 1.1, y: -2, transition: { type: 'spring', stiffness: 400, damping: 10 } }}
              style={{ '--social-color': social.color }}
              aria-label={social.name}
              title={social.name}
            >
              <i className={`${social.icon} social-icon`}></i>
            </motion.a>
          ))}
        </motion.div>
      </div>
      <div className="footer-bottom">
        <p className="copyright">&copy; {currentYear} KNOWNDISC. All rights reserved.</p>
      </div>
    </motion.footer>
  );
};

export default Footer;
